import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import get from 'lodash/get';
import {push as changeURL} from 'react-router-redux';
import DocumentTitle from 'react-document-title';
import {Helmet} from 'react-helmet';

import mapDispatch from '~/misc/mapDispatch';
import Results from '~/components/search/results/results';
import Spinner from '~/components/common/Spinner';
import {getResource} from '~/misc/resourceId';
import {getBrokerName, getBrokerDescName, resource} from '~/misc/brokers';
import {resourcesSaveBroker, resourcesRemoveBroker} from '~/modules/resources/actions';

import sharedCSS from '../shared.css';
import css from './index.css';

const noneQuery = {};

const resultsCount = (count, one, many) =>
  `${count} ${count === 1 ? one : many}`;

const brokerName = (name, DOT, notFound, totalDesc) => {
  if (notFound) {
    return `Broker DOT #${DOT} not found`;
  }

  const loadsDesc = totalDesc ? (`${totalDesc }, `) : '';

  if (!name) {
    return `${loadsDesc} Broker DOT #${DOT}`;
  }

  return `${loadsDesc} ${name}, DOT #${DOT}`;
};

const BrokerPage = ({isLoggedIn, goToRoot, DOT,
  loads, loadingLoads, resourcesSaveBroker, resourcesRemoveBroker,
  name, descName, notFound, totalDesc, address,
}) => {
  let saveBrokerFun = (data) => {
    resourcesSaveBroker({...data, dot: DOT});
  };
  let removeBrokerFun = (data) => {
    resourcesRemoveBroker({...data, dot: DOT});
  };
  return (
    <div className={cs(sharedCSS.wideStretchable, sharedCSS.box, sharedCSS.unpadded, css.main)}>
      <DocumentTitle title={`${brokerName(name, DOT, notFound, totalDesc)} - Truckloads Loadboard`}/>
      <Helmet>
        <meta
          name='description'
          content={
            `${brokerName(name, DOT)}, ${totalDesc} - Truckloads Loadboard`
          }
        />
      </Helmet>
      <div className={css.linkWrap}>
        <a className={css.link} onClick={goToRoot}>← search</a><br/>
      </div>
      <h1 className={css.header}>
        <span className={css.headerMain}>{name && name}</span>{' '}
        {descName && <span className={css.descName}>{descName}</span>}
        <span className={css.dotPart}>DOT: {DOT}</span>{' '}
      </h1>
      {' '}
      {address && <div className={css.addressBlock}>
        <span>{address.street}</span><br/>
        <span>{address.city} {address.state}, <i>{address.zip}</i></span>

      </div>}
      {notFound && <div>Broker not found</div>}
      <br/>
      <div className={css.loadsBlock}>
        {loadingLoads && <Spinner/>}
        {loads && <Results
          hidePremiumRow={!isLoggedIn}
          header={<h2 className={css.loadsHeader}>{totalDesc}</h2>}
          query={noneQuery}
          hasItems={loads.total_shipments > 0}
          total={loads.total_shipments}
          results={loads}
          sorting={false}
          identity={loads.identity}
          saveClick={true}
          collectionTheCompany={saveBrokerFun}
          noCollectionCompany={removeBrokerFun}
          hideClick={false}
        />}
      </div>
    </div>
  );
};

export default connect((state, {params: {DOT}}) => {
  const brokersData = get(getResource(state, resource), 'item');

  const broker = get(state.brokers, ['byDOT', DOT]);
  const loadsIdentity = broker && broker.loadsIdentity;
  const loads = getResource(state, loadsIdentity);
  const {
    loading,
    error,
    item,
  } = loads || {};

  const saferwatch = getResource(state, broker.saferwatchIdentity);

  const mainName = brokersData && getBrokerName(brokersData, DOT, true);
  const dbaName = get(saferwatch,
    'item[CarrierService.CarrierLookup].CarrierDetails.Identity.dbaName');
  const legalName = get(saferwatch,
    'item[CarrierService.CarrierLookup].CarrierDetails.Identity.legalName');
  const descName = (brokersData && getBrokerDescName(brokersData, DOT)) || !mainName && dbaName && legalName;

  const name = mainName
    || dbaName
    || legalName
    || get(item, 'shipments.0.company');

  const notFound = get(loads, 'completed') && get(saferwatch, 'completed') && !name;

  const address = get(saferwatch, 'item.identity-data.address');

  return {
    loads: item || null,
    loadingLoads: loading,
    error,
    DOT,
    name,
    address,
    descName: descName || null,
    notFound,
    isLoggedIn: state.user.isLoggedIn,
    totalDesc: (item && !loading && resultsCount(item.total_shipments, 'load', 'loads')) || '',
  };
}, mapDispatch({
  goToRoot: () => changeURL('/'),
  resourcesSaveBroker: (props, data) => resourcesSaveBroker(data),
  resourcesRemoveBroker: (props, data) => resourcesRemoveBroker(data),
}))(BrokerPage);



// WEBPACK FOOTER //
// ./src/components/BrokerPage/index.js